module.exports = __webpack_public_path__ + "img/catalina-top-angle.36de4058.png";